import Accordion from '@/common/components/atom/accordion';
import Breadcrumbs from '@/common/components/atom/breadcrumbs';
import { MenuItem, MenuList } from '@/common/components/atom/menu';
import Text from '@/common/components/atom/text';
import ChevronIcon from '@/common/components/icons/chevron';
import useCustomize from '@/common/hooks/useCustomize';
import { useSearch } from '../../hooks/useSearch';
import { Fragment } from '@/common/fragment';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import useIsNewAppShell from '@/common/hooks/useIsNewAppShell';

export const SearchSeoBox = () => {
  const customize = useCustomize(state => state.customize);
  const { seoInfo, footers } = useSearch();
  const showPlasmicSeo = useFeatureIsOn('search_plasmic_seo');
  const isApp = useIsNewAppShell();

  // SEO text and breadcrumbs are for search engines, not for people in the app.
  if (isApp) return null;

  if (showPlasmicSeo) {
    return (
      <Fragment
        name="SeoBox"
        props={{
          seoInfo: seoInfo,
          footer: footers,
        }}
      />
    );
  }

  return (
    <>
      {!!seoInfo?.breadcrumbs && (
        <Breadcrumbs
          className="py-5"
          items={seoInfo.breadcrumbs.map((item, index, items) => ({ ...item, href: index + 1 < items.length ? item.href : '' }))}
        />
      )}
      {customize.showSeoBoxs && (
        <div className="flex pwa:hidden flex-col !mt-5 space-y-2">
          <Text as="h1" fontWeight="bold">
            {seoInfo?.heading}
          </Text>
          <Text as="p" fontSize="sm">
            {seoInfo?.description}
          </Text>
          <Accordion title="درباره این صفحه" className="!bg-white shadow-card !mt-5">
            <div className="text-justify text-sm [&>h2]:font-bold" dangerouslySetInnerHTML={{ __html: seoInfo?.seo_box ?? '' }} />
            {footers?.map((item: any, index: any) => (
              <Accordion key={index} title={item.title} className="mt-2">
                <MenuList className="flex !flex-row flex-wrap gap-x-14">
                  {item.items.map((menu: any) => (
                    <MenuItem key={menu.name} name={menu.name} link={menu.url} className="flex-[1_1_25rem] !justify-start">
                      <ChevronIcon dir="left" />
                    </MenuItem>
                  ))}
                </MenuList>
              </Accordion>
            ))}
          </Accordion>
        </div>
      )}
    </>
  );
};

export default SearchSeoBox;

